import { render } from "./document-callback.vue?vue&type=template&id=4098d1f0&scoped=true"
import script from "./document-callback.vue?vue&type=script&lang=js"
export * from "./document-callback.vue?vue&type=script&lang=js"

import "./document-callback.vue?vue&type=style&index=0&id=4098d1f0&scoped=true&lang=css"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4098d1f0"]])

export default __exports__